import { addCalendarDays, sameCalendarDay, toIsoDate } from '@/utils/calendar/date'
import type {
  CalendarGridEvent,
  CalendarMonthCell,
  CalendarMonthListEvent
} from '@/types/calendar/grid'

export function buildMonthRows(
  selectedDate: Date,
  today: Date,
  monthNamesShort: string[]
): CalendarMonthCell[][] {
  const y = selectedDate.getFullYear()
  const m = selectedDate.getMonth()
  const first = new Date(y, m, 1)
  const startOffset = (first.getDay() + 6) % 7
  const gridStart = addCalendarDays(first, -startOffset)
  const rows: CalendarMonthCell[][] = []

  for (let r = 0; r < 6; r++) {
    const row: CalendarMonthCell[] = []
    for (let c = 0; c < 7; c++) {
      const d = addCalendarDays(gridStart, r * 7 + c)
      const inMonth = d.getMonth() === m
      row.push({
        date: d,
        day: d.getDate(),
        currentMonth: inMonth,
        isToday: sameCalendarDay(d, today),
        isSelected: inMonth && sameCalendarDay(d, selectedDate),
        monthLabel: d.getDate() === 1 ? monthNamesShort[d.getMonth()] : undefined
      })
    }
    rows.push(row)
  }
  return rows
}

export function monthListEventsFor(
  cell: CalendarMonthCell,
  eventsByDate: Map<string, CalendarGridEvent[]>
): CalendarMonthListEvent[] {
  if (!cell.currentMonth) {
    return []
  }
  return (eventsByDate.get(toIsoDate(cell.date)) ?? [])
    .slice()
    .sort((a, b) => a.startMin - b.startMin)
    .map((e) => ({
      title: e.title,
      tone: e.tone,
      type: e.type
    }))
}
